module.exports = __webpack_public_path__ + "img/四川天府新区金星幼儿园.f6180898.jpg";